/* (ASYNC) */
export const FETCH_ASSIGNMENT_LIST_SETTING_INIT = 'FETCH_ASSIGNMENT_LIST_SETTING_INIT';
export const FETCH_ASSIGNMENT_LIST_SETTING_SUCCESS = 'FETCH_ASSIGNMENT_LIST_SETTING_SUCCESS';
export const FETCH_ASSIGNMENT_LIST_SETTING_FAILURE = 'FETCH_ASSIGNMENT_LIST_SETTING_FAILURE';

export const FETCH_ASSIGNMENT_LIST_INIT = 'FETCH_ASSIGNMENT_LIST_INIT';
export const FETCH_ASSIGNMENT_LIST_SUCCESS = 'FETCH_ASSIGNMENT_LIST_SUCCESS';
export const FETCH_ASSIGNMENT_LIST_FAILURE = 'FETCH_ASSIGNMENT_LIST_FAILURE';



// WEBPACK FOOTER //
// ./source/client/actions/assignment_list/types.js